/** @jsxImportSource @emotion/react */
import PropTypes from "prop-types";
import Dropdown from "../../../components/Dropdown";

const DrawerLocationCard = ({
  classes,
  offerDetailsCardRef,
  countryList,
  stateData,
  countyData,
  cityData,
  selCountry,
  selState,
  selCounty,
  selCity,
  userDetails,
  onChangeHandler,
  onDefaultAddress,
}) => (
  <>
    <div
      css={[classes.locationDetailsContentWrapper]}
      ref={offerDetailsCardRef}
    >
      <Dropdown
        label={"Country"}
        component={"autocomplete"}
        lists={countryList}
        value={selCountry}
        renderKey={"name"}
        renderValue={"uuid"}
        onChange={(e, value) => onChangeHandler("country", value)}
      />
      <Dropdown
        label={"State"}
        component={"autocomplete"}
        lists={stateData}
        value={selState}
        renderKey={"name"}
        renderValue={"uuid"}
        onChange={(e, value) => onChangeHandler("state", value)}
      />
      <Dropdown
        label={"County"}
        component={"autocomplete"}
        lists={countyData}
        value={selCounty}
        renderKey={"name"}
        renderValue={"uuid"}
        onChange={(e, value) => onChangeHandler("county", value)}
      />
      <Dropdown
        label={"City"}
        component={"autocomplete"}
        lists={cityData}
        value={selCity}
        renderKey={"name"}
        renderValue={"uuid"}
        onChange={(e, value) => onChangeHandler("city", value)}
      />
    </div>
    {(userDetails?.address?.city !== selCity ||
      userDetails?.address?.county !== selCounty ||
      userDetails?.address?.state !== selState) && (
      <div
        css={[classes.locationDetailsContentWrapper]}
        ref={offerDetailsCardRef}
      >
        <button css={[classes.buttons]} onClick={onDefaultAddress}>
          Change to Default Address
        </button>
      </div>
    )}
  </>
);

DrawerLocationCard.propTypes = {
  classes: PropTypes.object.isRequired,
  offerDetailsCardRef: PropTypes.object,
  countryList: PropTypes.array,
  stateData: PropTypes.array,
  countyData: PropTypes.array,
  cityData: PropTypes.array,
  selCountry: PropTypes.string,
  selState: PropTypes.string,
  selCounty: PropTypes.string,
  selCity: PropTypes.string,
  userDetails: PropTypes.object,
  onChangeHandler: PropTypes.func.isRequired,
  onDefaultAddress: PropTypes.func.isRequired,
};

export default DrawerLocationCard;
